export default function XQuery_Select() {
  return (
    <div>
      <h1>XQuery_Select</h1>
      <p>This is the XQuery_Select component.</p>
    </div>
  );
}